import { render } from "./Spotlight.vue?vue&type=template&id=4ee7ee7e"
import script from "./Spotlight.vue?vue&type=script&lang=js"
export * from "./Spotlight.vue?vue&type=script&lang=js"

import "./Spotlight.vue?vue&type=style&index=0&id=4ee7ee7e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__